<template>
  <div class="HeaderBanner">
    <picture class="Imgholder">
      <source media="(max-width: 375px)" :srcset="imgSrcMobile">
      <source media="(min-width: 376px)" :srcset="imgSrcDesktop">
      <img class="BannerImg" :src="imgSrcDesktop" alt="BannerImg">
    </picture>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'header-banner',

    props: {
      imgSrcDesktop: {
        type: String,
        default: require('@/assets/images/myaccount-banner.jpg')
      },
      imgSrcMobile: {
        type: String,
        default: require('@/assets/images/myaccount-banner.jpg')
      }
    }
  }
</script>

<style lang="scss">
  .HeaderBanner {
    position: relative;
    height: 2rem;
    background: $blue;

    @include media(tablet) {
      height: 2.28rem;
    }

    .Imgholder {
      height: 100%;
      overflow: hidden;
      display: block;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(14deg, rgba(0, 0, 0, 0) 0%, #000 100%);
      opacity: .4;
    }

    .BannerImg {
      width: 100%;
      object-fit: cover;
      min-height: 100%;
    }
  }
</style>
